/* This file is auto-generated with codeGen.ts. DO NOT MANUALLY EDIT! */
export default {
    geoextension: new Date("2026-02-09T18:20:44.000+01:00"),
    vier: new Date("2022-12-23T15:12:30.000+01:00"),
    rolit: new Date("2023-07-18T20:50:36.000+02:00"),
    skipbo: new Date("2025-09-05T16:26:23.000+02:00"),
    "whereigo-cracker": new Date("2025-08-21T20:35:27.000+02:00"),
    "super-wonder-captain": new Date("2019-11-02T18:48:45.000+01:00"),
    rooster: new Date("2022-12-11T18:15:01.000+01:00"),
    pris: new Date("2020-04-08T18:20:17.000+02:00"),
    clonebook: new Date("2024-01-14T10:50:46.000+01:00"),
    billy: new Date("2022-12-11T15:19:32.000+01:00"),
    botbot: new Date("2023-04-15T20:08:22.000+02:00"),
    tetris: new Date("2022-12-14T15:27:12.000+01:00"),
    lalaland: new Date("2023-11-10T08:56:59.000+01:00"),
    "mens-erger-je-niet": new Date("2023-01-20T20:25:25.000+01:00"),
    wifilogin: new Date("2026-03-26T21:39:56.000+01:00"),
    zwemapp: new Date("2022-10-10T19:19:16.000+02:00"),
    paywall: new Date("2022-10-16T20:09:40.000+02:00"),
    zwemtijden: new Date("2023-10-22T11:53:03.000+02:00"),
    libvirtmanager: new Date("2024-07-01T19:56:54.000+02:00"),
    "k3s-generator": new Date("2024-08-13T16:10:46.000+02:00"),
    updater: new Date("2025-10-05T20:56:53.000+02:00"),
    rquery: new Date("2023-08-22T18:10:54.000+02:00"),
    rubend: new Date("2025-09-05T18:49:06.000+02:00"),
    zeroscale: new Date("2024-12-19T19:54:06.000+01:00"),
    queuetimes: new Date("2024-11-04T16:31:44.000+01:00"),
    pdf: new Date("2023-08-05T19:04:02.000+02:00"),
    ov: new Date("2026-10-24T19:05:43.000+02:00"),
    AOC: new Date("2023-12-19T18:01:56.000+01:00"),
    swimtimer: new Date("2023-12-24T16:00:41.000+01:00"),
    ovRepeater: new Date("2026-10-11T10:19:34.000+02:00"),
    "vite-gql-codegen": new Date("2026-03-14T16:37:56.000+01:00"),
    "rate-cache": new Date("2026-02-25T16:16:03.000+01:00"),
    flux: new Date("2026-10-24T13:58:46.000+02:00"),
    charts: new Date("2026-07-29T13:30:14.000+02:00")
} as Record<string, Date>;